import React from 'react';

export function Recalled({ fill = 'currentColor' }: { fill?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_recalled)">
        <path
          d="M0 12C0 12.1313 0.053125 12.2594 0.146875 12.3531L4.14687 16.3531C4.34062 16.5469 4.65938 16.5469 4.85313 16.3531C5.04688 16.1594 5.04688 15.8406 4.85313 15.6469L1.70625 12.5H10.25C13.425 12.5 16 9.925 16 6.75C16 3.575 13.425 1 10.25 1H2.5L2.4 1.00937C2.17188 1.05625 2 1.25938 2 1.5C2 1.74063 2.17188 1.94375 2.4 1.99063L2.5 2H10.25C12.8719 2 15 4.12812 15 6.75C15 9.37187 12.875 11.5 10.25 11.5H1.70625L4.85313 8.35312L4.91875 8.275C5.04688 8.08125 5.025 7.81562 4.85313 7.64687C4.68125 7.47813 4.41875 7.45312 4.225 7.58125L4.14687 7.64687L0.146875 11.6469C0.053125 11.7406 0 11.8687 0 12Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_recalled">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
